import React, { useState, useContext, } from 'react';
import { Button, Typography, Row, Space, Col, Alert, Tooltip, Divider, } from 'antd';
import { PlusOutlined, DeleteOutlined, ExclamationCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { ScreenHeader } from '../../../UI/ScreenHeader.component';
import { Status } from '../Status/Status.component';
import { AddNewDeviceModal } from '../../Modals/AddNewDeviceModal.component';
import { StationContext, } from '../../../../context/station-context';
import { DeleteStationModal } from '../../Modals/DeleteStationModal.component';
import { PendingChangesModal } from '../../Modals/PendingChangesModal.component';
import { RefreshCustomerContext } from '../CustomerViewLayout.component';
import { findUniqueStation } from '../../../../services/MainService';
import { Restricted } from '../../../UI/Restricted.component';
import './StationHeader.css';

const { Title, } = Typography;
const btnSize = 'default';

export const StationHeader = ({ pendingState, setPendingState, setUpdateAllPendingChanges, baseDevices, ...props}) => {

    const value = useContext(RefreshCustomerContext);
    const { refresh, setRefresh, setRefreshMessage, } = value;

    const [stationState, stationDispatch ] = useContext(StationContext);
    const {station, pendingQueue} = stationState;
    const [addNewDeviceModal, setAddNewDeviceModal] = useState(false);
    const [deleteStationModal, setDeleteStationModal] = useState(false);
    const [pendingChangesModal, setPendingChangesModal] = useState(false);

    const scrollTop = () => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
        });
    };

    const refreshHandler = () => {
        setRefresh(true);
        findUniqueStation({id: station?.id}).then( function ( response ){
            if( response ) {
                stationDispatch({
                    type: "SET_STATION",
                    payload: response,
                });
            }
        })
        setRefreshMessage(`${station.name} is up to date.`)
    }

    return(
        <>
            <ScreenHeader 
                className={`station__header station__header--sticky ${props.className || ''}`}
                >
                <Row justify="space-between" align="bottom" style={{gap: 5}}>
                    <Col flex={1}>
                        <Title level={5} style={{fontWeight: 800}}>Station</Title>  
                        <Space size="middle" align="center" style={{width: "100%"}}>
                            <Title onClick={scrollTop}>{station.name}</Title>
                            <Status bordered status={station.status} text='INTERNET STATUS' blink={station.status !== null && (station.status ? false : true) }/>
                        </Space>
                    </Col>
                    <Restricted to='station.edit'>
                        <Col>
                            <Space size="small" align="center" >
                                <Restricted to='device.add'>
                                    <Button onClick={() => setAddNewDeviceModal(true)} size={btnSize} ghost type="primary" icon={<PlusOutlined/>}>Add New Device</Button>
                                </Restricted>
                                { pendingQueue?.length > 0 ? 
                                    <>
                                        {/* <Button onClick={() => setUpdateAllPendingChanges(true)} size={btnSize} className='btn__warning' style={{color: 'white'}} icon={<ExclamationCircleFilled/>}>Update Station</Button> */}
                                        <Restricted to='device.edit'>
                                            <Space>
                                                <Button onClick={() => setPendingChangesModal(true)} size={btnSize} color='yellow' variant='solid' icon={<ExclamationCircleOutlined/>}>Undo Changes</Button>
                                                <Tooltip title='Devices with pending changes' placement='bottomRight'>
                                                    <Alert message={<code>{pendingQueue?.length}</code>} type="warning" showIcon style={{padding: '4px 15px', }} />
                                                </Tooltip>
                                            </Space>
                                        </Restricted>
                                    </>
                                : 
                                    <>
                                        <Button type='primary' icon={<SyncOutlined />} loading={refresh} onClick={() => refreshHandler()}>Refresh</Button>
                                        <Restricted to='station.delete'>
                                            <Button onClick={() => setDeleteStationModal(true)} size={btnSize} danger type="primary" icon={<DeleteOutlined/>} />
                                        </Restricted>
                                    </>
                                }
                            </Space>  
                        </Col>
                    </Restricted>
                </Row>
                <Divider style={{marginBottom: 0}}/>
            </ScreenHeader>

            { addNewDeviceModal && 
                <Restricted to='device.add'>
                    <AddNewDeviceModal addNewDeviceModal={addNewDeviceModal} setAddNewDeviceModal={setAddNewDeviceModal} baseDevices={baseDevices} /> 
                </Restricted>
            }

            { deleteStationModal && 
                <Restricted to='station.delete'>
                    <DeleteStationModal deleteStationModal={deleteStationModal} setDeleteStationModal={setDeleteStationModal}/> 
                </Restricted>
            }
            
            { pendingChangesModal && 
                <Restricted to='device.edit'>
                    <PendingChangesModal 
                        title='Undo Changes?'
                        type='warning'
                        message='Are you sure you want to discard ALL changes? Changes will not be saved.' 
                        displayModal={pendingChangesModal} 
                        setDisplayModal={setPendingChangesModal}
                        setPendingState={setPendingState}
                    />
                </Restricted>
            }
        </>
    );
};